var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcWellness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "#EAF5DE"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#88C344",
    d: "M42.908 35.227a28.223 28.223 0 0 1 2.843-3.943h.001c1.05-1.207 3.108-2.757 3.108-2.757.309-.234.276-.56-.076-.723l-2.486-1.162a.91.91 0 0 0-1.062.265s-1.84 2.638-4.004 8.253c-6.691-3.026-13.052 1.213-13.052 8.585 0 7.7 5.924 19.398 13.936 15.867 8.438 3.652 13.94-8.165 13.94-15.867 0-7.435-5.717-11.795-13.148-8.518z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#447210",
    fillOpacity: 0.679,
    d: "M41.41 32.733a.862.862 0 0 0 .76-.761s.248-3.011-1.85-5.112c-2.106-2.101-5.112-1.85-5.112-1.85a.864.864 0 0 0-.76.76s-.252 3.013 1.849 5.114c2.1 2.1 5.113 1.849 5.113 1.849z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWellness);
export default __webpack_public_path__ + "static/media/ic-wellness.a9493810f3f58daefeff60aa73115a13.svg";
export { ForwardRef as ReactComponent };